import React from 'react';
import bankSrc from '@/assets/img/bank.png';
import { renderIntlLabel } from '@/utils';
import { parseFen2Currency } from '@/utils/number';
import styles from './bank.module.scss';

const Bank = ({ payAmount }) => {
  return (
    <>
      <div className={styles.container}>
        <div className={styles.money}>{parseFen2Currency(payAmount)}</div>
        <img
          className={styles.img}
          alt={renderIntlLabel('bill_label_offline_bank')}
          src={bankSrc}
        />
        <div>{renderIntlLabel('bill_label_receive_moeny_by_offline_bank')}</div>
        <div>*{renderIntlLabel('bill_label_tips_confirm_receive_money_in_POS')}</div>
      </div>
    </>
  );
};

export default Bank;
